
import { useKeyTraits } from "@/hooks/useKeyTraits";
import { BehavioralFactor } from "@/types/resultsTypes";

export function usePersonalityStoryData(behavioralFactors: BehavioralFactor[]) {
  const { getTraitForFactor } = useKeyTraits();
  return behavioralFactors.map((factor) =>
    getTraitForFactor(factor.key as any, factor.percentile)
  );
}
